import { useEffect, useRef, useState } from "react";

export default function StatCounter({
  value,
  label,
  suffix = "",
  duration = 2000,
}) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      },
      { threshold: 0.5 },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started) return;
    const FRAME_DURATION_MS = 16;
    const numValue = parseInt(String(value).replace(/\D/g, ""), 10);
    const step = Math.ceil(numValue / (duration / FRAME_DURATION_MS));
    let current = 0;
    const timer = setInterval(() => {
      current = Math.min(current + step, numValue);
      setCount(current);
      if (current >= numValue) clearInterval(timer);
    }, 16);
    return () => clearInterval(timer);
  }, [started, value, duration]);

  return (
    <div ref={ref} className="text-center">
      <div className="text-4xl font-bold text-primary-600 mb-1">
        {count}
        {suffix}
      </div>
      <div className="text-gray-600 text-sm font-medium">{label}</div>
    </div>
  );
}
